import { render } from "./Methodology.vue?vue&type=template&id=8b2d217c&scoped=true"
import script from "./Methodology.vue?vue&type=script&lang=js"
export * from "./Methodology.vue?vue&type=script&lang=js"

import "./Methodology.vue?vue&type=style&index=0&id=8b2d217c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2d217c"]])

export default __exports__